<script>
  import { onMount } from "svelte";

  let { jwt } = $props();

  localStorage.removeItem("unitCustomerToken");
  localStorage.removeItem("unitVerifiedCustomerToken");

  let container;
  const unit = document.createElement("unit-elements-white-label-app");

  unit.setAttribute("jwt-token", jwt);
  unit.setAttribute("id", "unit-vb-embed");

  onMount(() => {
    container.append(unit);
  });
</script>

<div
  bind:this={container}
  id="group-digital-banking-container"
  class="tw:container tw:mt-10"
></div>
